module.exports = __webpack_public_path__ + "img/img27.6280410f.png";